module.exports = __webpack_public_path__ + "img/ic-logo-airwallex.fd60a0c2.svg";